<!--
 * @Author: your name
 * @Date: 2020-09-16 16:53:33
 * @LastEditTime: 2020-12-29 21:16:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\contractInfo\controlData\index.vue
-->
<template>
    <div class="controlData">
        <van-nav-bar
            title="管控数据"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="wrapper">
            <!-- 授信金额、合同欠款 -->
            <div class="row-con1">
                <div>
                    <h4>授信金额</h4>
                    <div class="num-block">
                        <div>
                            <div class="tit">
                                金额(元)
                            </div>
                            <van-popover v-model="showPopover1" trigger="click" @open="isOpenPover(1,controlDetails.credit_money)">
                                <div class="num num-blue">
                                    {{ controlDetails.credit_money || 0 }}
                                </div>
                                <template #reference>
                                    <div class="num num-blue">
                                        {{ controlDetails.credit_money || 0 }}
                                    </div>
                                </template>
                            </van-popover>
                        </div>
                        <div>
                            <div class="tit">
                                剩余授信金额(元)
                            </div>
                            <van-popover v-model="showPopover2" trigger="click" @open="isOpenPover(2,controlDetails.credit_surplus_money)">
                                <div class="num num-orange">
                                    {{ controlDetails.credit_surplus_money || 0 }}
                                </div>
                                <template #reference>
                                    <div class="num num-orange">
                                        {{ controlDetails.credit_surplus_money || 0 }}
                                    </div>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                </div>
                <div>
                    <h4>授信方量</h4>
                    <div class="num-block">
                        <div>
                            <div class="tit">
                                方量(方)
                            </div>
                            <van-popover v-model="showPopover3" trigger="click" @open="isOpenPover(3,controlDetails.credit_quantity)">
                                <div class="num num-blue">
                                    {{ controlDetails.credit_quantity || 0 }}
                                </div>
                                <template #reference>
                                    <div class="num num-blue">
                                        {{ controlDetails.credit_quantity || 0 }}
                                    </div>
                                </template>
                            </van-popover>
                        </div>
                        <div>
                            <div class="tit">
                                剩余授信方量(方)
                            </div>
                            <van-popover v-model="showPopover4" trigger="click" @open="isOpenPover(4,controlDetails.credit_surplus_quantity)">
                                <div class="num num-orange">
                                    {{ controlDetails.credit_surplus_quantity || 0 }}
                                </div>
                                <template #reference>
                                    <div class="num num-orange">
                                        {{ controlDetails.credit_surplus_quantity || 0 }}
                                    </div>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                </div>
                <div class="contractArrears">
                    <h4>
                        <span>合同欠款</span>
                        <span class="iconfont iconiconset0143" @click="showHtqk=true"></span>
                    </h4>
                    <div class="num-block">
                        <div>
                            <div class="tit">
                                金额(元)
                            </div>
                            <van-popover v-model="showPopover5" trigger="click" @open="isOpenPover(5,controlDetails.cumulative_balance)">
                                <div class="num num-red">
                                    {{ controlDetails.cumulative_balance || 0 }}
                                </div>
                                <template #reference>
                                    <div class="num num-red">
                                        {{ controlDetails.cumulative_balance || 0 }}
                                    </div>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                </div>
            </div>
            <van-dialog v-model="showHtqk" class="tipsDialog">
                <div>
                    <span>合同欠款</span>
                    <i class="equal">=</i>
                    <span>订单总金额</span>
                    <i class="reduce">-</i>
                    <span>回款金额</span>
                </div>
            </van-dialog>
            <!-- 订单总金额 -->
            <div class="row-con2">
                <h4>
                    <span>订单总金额</span>
                    <span class="iconfont iconiconset0143" @click="alertTips('订单总金额')"></span>
                </h4>
                <div class="block-con">
                    <div class="num-block">
                        <div class="tit">
                            订单个数(个)
                        </div>
                        <van-popover v-model="showPopover6" trigger="click" @open="isOpenPover(6,controlDetails.order_count)">
                            <div class="num num-orange">
                                {{ controlDetails.order_count }}
                            </div>
                            <template #reference>
                                <div class="num num-orange">
                                    {{ controlDetails.order_count }}
                                </div>
                            </template>
                        </van-popover>
                    </div>
                    <div class="num-block">
                        <div class="tit">
                            订单方量(方)
                        </div>
                        <van-popover v-model="showPopover7" trigger="click" @open="isOpenPover(7,controlDetails.order_total_quantity)">
                            <div class="num num-orange">
                                {{ controlDetails.order_total_quantity }}
                            </div>
                            <template #reference>
                                <div class="num num-orange">
                                    {{ controlDetails.order_total_quantity }}
                                </div>
                            </template>
                        </van-popover>
                    </div>
                    <div class="num-block">
                        <div class="tit">
                            订单金额(元)
                        </div>

                        <van-popover v-model="showPopover8" trigger="click" @open="isOpenPover(8,controlDetails.order_total_money)">
                            <div class="num num-orange">
                                {{ controlDetails.order_total_money }}
                            </div>
                            <template #reference>
                                <div class="num num-orange">
                                    {{ controlDetails.order_total_money }}
                                </div>
                            </template>
                        </van-popover>
                    </div>
                </div>
            </div>
            <!-- 发货总金额 -->
            <div class="total-account">
                <h4>
                    <span>发货总金额</span>
                    <span class="iconfont iconiconset0143" @click="showFhsje=true"></span>
                </h4>
                <van-dialog v-model="showFhsje" class="tipsDialog">
                    <div>
                        <span>补录截止日之后系统中发货计算的金额(上线场站)</span>
                        <i class="add">+</i>
                        <span>补录截止日之后按日补录发货金额(非上线场站)</span>
                    </div>
                </van-dialog>
                <div class="block">
                    <div class="top">
                        <div>
                            <p>订单个数(个)</p>
                            <h4>{{ controlDetails.delivery_count || 0 }}</h4>
                        </div>
                        <div>
                            <p>发货总方量(方)</p>
                            <h4>{{ controlDetails.delivery_total_quantity || 0 }}</h4>
                        </div>
                        <div>
                            <p>发货总金额(元)</p>
                            <h4>{{ controlDetails.delivery_total_money || 0 }}</h4>
                        </div>
                    </div>
                    <div class="top-tip">
                        <div class="tit">
                            其中
                        </div>
                        <div class="row-con">
                            <div class="row-item">
                                <span class="info">已核对核算(元)：</span>
                                <span class="num">{{ controlDetails.delivery_check_money || 0 }}</span>
                                <span class="iconfont iconiconset0143" @click="alertTips('已核对核算')"></span>
                            </div>
                            <div class="row-item">
                                <span class="info">已办结签收，未核对(元)：</span>
                                <span class="num">{{ controlDetails.delivery_sign_money || 0 }}</span>
                                <span class="iconfont iconiconset0143" @click="alertTips('已办结')"></span>
                            </div>
                            <div class="row-item">
                                <span class="info">已打料完成未办结(签收)(元)：</span>
                                <span class="num">{{ controlDetails.delivery_product_money || 0 }}</span>
                                <span class="iconfont iconiconset0143" @click="alertTips('已打料')"></span>
                            </div>
                            <div class="row-item">
                                <span class="info">已派单未打料完成(元)：</span>
                                <span class="num">{{ controlDetails.delivery_dispatch_money || 0 }}</span>
                                <span class="iconfont iconiconset0143" @click="alertTips('已派单')"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 回款金额 -->
            <div class="amount-received">
                <h4>
                    <span>回款金额</span>
                    <span class="iconfont iconiconset0143" @click="showHkje=true"></span>
                </h4>
                <van-dialog v-model="showHkje" class="tipsDialog">
                    <div>
                        <span>补录截止日之后的收款记录</span>
                        <i class="reduce">-</i>
                        <span>补录数据最后一期的应收余额</span>
                        <i class="reduce">-</i>
                        <span>补录截止日之后的退款记录</span>
                    </div>
                </van-dialog>
                <div class="block">
                    <div class="top">
                        <div>
                            <p>笔数(笔)</p>
                            <h4>{{ controlDetails.cashed_total_count || 0 }}</h4>
                        </div>
                        <div>
                            <p>金额(元)</p>
                            <h4>{{ controlDetails.cashed_total_money || 0 }}</h4>
                        </div>
                    </div>
                    <div class="split"></div>
                    <div class="bottom">
                        <div>其中</div>
                        <div>
                            <div>
                                <p>收款(元)</p>
                                <h4>{{ controlDetails.cashed_amount || 0 }}</h4>
                            </div>
                            <div>
                                <p>补录末期<br>应收余额(元)</p>
                                <h4>{{ controlDetails.zkbl_accounts_receivable_balance || 0 }}</h4>
                            </div>
                            <div>
                                <p>退款(元)</p>
                                <h4>{{ controlDetails.refund_receipt || 0 }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
    name: 'control-data',
    components: {},
    props: {},
    data() {
        return {
            contract_number: '',
            controlDetails: {},
            // 弹出说明文字
            showHtqk: false,
            showFhsje: false,
            showHkje: false,

            showPopover1: false,
            showPopover2: false,
            showPopover3: false,
            showPopover4: false,
            showPopover5: false,
            showPopover6: false,
            showPopover7: false,
            showPopover8: false,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.contract_number = this.$route.params.contract_number;
        this.handleData();
    },
    methods: {
        isOpenPover(flag, val) {
            const isShow = (val + '').length >= 8;
            switch (flag) {
                case 1: this.showPopover1 = isShow; break;
                case 2: this.showPopover2 = isShow; break;
                case 3: this.showPopover3 = isShow; break;
                case 4: this.showPopover4 = isShow; break;
                case 5: this.showPopover5 = isShow; break;
                case 6: this.showPopover6 = isShow; break;
                case 7: this.showPopover7 = isShow; break;
                case 8: this.showPopover8 = isShow; break;
            }
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 弹出提示信息
        alertTips(type) {
            let str = '';
            if (type === '订单总金额') {
                str = '订单创建时间为补录截止日之后审核通过的订单总金额（如果某个订单的发货总金额大于任务总金额，则订单总金额取该订单的发货总金额）';
            } else if (type === '已核对核算') {
                str = '未到结算期，按站统计核对调整后的方量，结算中心已核算的发货金额';
            } else if (type === '已办结') {
                str = '司机送达/办结后，按客户录入签收方量，系统自动计算的发货金额';
            } else if (type === '已打料') {
                str = '已打料完成，按发货单上打印的方量，系统自动计算的发货金额';
            } else if (type === '已派单') {
                str = '按调度派单且司机已接单的派车单的发货方量，系统自动计算的发货金额';
            }
            Dialog.alert({
                message: str,
            }).then(() => {
                // on close
            });
        },
        // 处理管控数据
        async handleData() {
            const res = await this.getData();
            if (res) {
                this.controlDetails = res;
            }
        },
        // 查询管控数据
        getData() {
            const path = '/interfaceApi/sale/control/data/' + this.contract_number + '/2';
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
@import './index.styl'
</style>
